module.exports = __webpack_public_path__ + "img/cloud_right_1.225d7b89.png";